

const api = `/account`

export const accountendpoints = () => {

    const self = {

        one: (username: string) => `${api}/${username}`,
        all: () => api,
        providers: () => `${api}/provider`,
        verifyOne: (username: string) => `${self.one(username)}/verify`,
        activateOne: (username: string) => `${self.one(username)}/activate`,
        resetOne: (username: string) => `${self.one(username)}/reset`,
        suspendOne: (username: string) => `${self.one(username)}/suspend`,
        suspendMany: () => `${self.all()}/suspend`

    }

    return self

}